/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetUserByIdOptions,
  GetUserByIdStatus200,
  GetUserByIdStatus400,
  GetUserByIdStatus404,
  GetUserByIdStatus500,
} from '../types/GetUserById'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getUserById } from '../clients/getUserById'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUserByIdQueryKey = ({ path }: Omit<GetUserByIdOptions, 'headers'>) =>
  [{ url: '/v1/user/:user_id', params: path }] as const

type GetUserByIdQueryKey = ReturnType<typeof getUserByIdQueryKey>

export function getUserByIdQueryOptions(
  { path }: GetUserByIdOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getUserByIdQueryKey({ path })
  return queryOptions<
    GetUserByIdStatus200,
    ResponseErrorConfig<GetUserByIdStatus400 | GetUserByIdStatus404 | GetUserByIdStatus500>,
    GetUserByIdStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserById({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get user by ID (admin only)
 * {@link /v1/user/:user_id}
 */
export function useGetUserById<
  TData = GetUserByIdStatus200,
  TQueryData = GetUserByIdStatus200,
  TQueryKey extends QueryKey = GetUserByIdQueryKey,
>(
  { path }: { path: GetUserByIdOptions['path'] | (() => GetUserByIdOptions['path']) },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUserByIdStatus200,
        ResponseErrorConfig<GetUserByIdStatus400 | GetUserByIdStatus404 | GetUserByIdStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getUserByIdQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getUserByIdQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetUserByIdStatus400 | GetUserByIdStatus404 | GetUserByIdStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
